var map = {
	"./en-US": [
		"8bda",
		"chunk-2d0e921d"
	],
	"./en-US.ts": [
		"8bda",
		"chunk-2d0e921d"
	],
	"./ru-RU": [
		"c5a8",
		"chunk-2d21749f"
	],
	"./ru-RU.ts": [
		"c5a8",
		"chunk-2d21749f"
	],
	"./zh-CN": [
		"0d82",
		"chunk-2d0af124"
	],
	"./zh-CN.ts": [
		"0d82",
		"chunk-2d0af124"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "04c2";
module.exports = webpackAsyncContext;